import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const BarcodeScanner = lazy(() => import('./barcode-scanner.component'));

export function useBarcodeScannerRoutes() {
    return (
        <Route path='open_scanner'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <BarcodeScanner />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
